import { render } from "./BattleDetailView.vue?vue&type=template&id=bbf539c2"
import script from "./BattleDetailView.vue?vue&type=script&lang=js"
export * from "./BattleDetailView.vue?vue&type=script&lang=js"

import "./BattleDetailView.vue?vue&type=style&index=0&id=bbf539c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__